import { DownloadIcon } from "lucide-react";

import { DocumentPreview } from "@/components";
import { Button } from "@/components/ui/button";

export const JobPipelineCandidateSheetResumeContainer = ({
  href,
}: {
  href: string;
}) => {
  return (
    <div className="border border-slate-200">
      <div className="border-b border-slate-200 p-4">
        <Button
          className="h-auto w-auto p-0 hover:bg-transparent"
          variant="ghost"
        >
          <a
            className="flex items-center gap-2"
            href={href}
            rel="noreferrer"
            target="_blank"
            download
          >
            <DownloadIcon className="h-4 w-4" />
            Download Resume
          </a>
        </Button>
      </div>
      <div className="max-h-[75vh] overflow-y-scroll">
        <DocumentPreview href={href} />
      </div>
    </div>
  );
};
